<template lang="html">
  <div>
    <div
      class="item-cells product-label"
      @click="showLabels"
      v-if="newExp.length > 0"
    >
      <ul class="item-cell-bd">
        <li v-for="explanation in newExp">
          <span>
            <i class="iconfont icon-roundcheck guanbi"></i>
            <span class="title">{{ explanation.title }}</span>
          </span>
        </li>
      </ul>
      <div class="item-cell-ft">
        <img class="icon-more" src="~@/assets/images/home/sx_icon_pop@3x.png" />
      </div>
    </div>
    <popup v-model="status" @closed="handleClosed">
      <div class="newlabel">
        <div class="header">
          服务说明
          <i class="iconClose" @click="handleClosed"></i>
        </div>
        <div class="newlabelC">
          <labelcontent></labelcontent>
        </div>
        <div class="btn">
          <div @click="handleClosed" class="btnRed">确定</div>
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Popup from '@/components/action-sheet/popup'
import labelcontent from './label-pop'
import PROUDCT_TYPE from '@/router/home/components/product/product-intro/config'

export default {
  props: {
    product: {
      type: Object
    }
  },
  data() {
    return {
      status: false
    }
  },
  components: {
    Popup,
    labelcontent
  },
  computed: {
    ...mapState(['serveExplanation', 'selectedSku']),
    isRebuilding() {
      // 产后恢复
      return (
        this.product &&
        this.product.spuId &&
        this.product.level4CategoryId &&
        parseInt(+this.product.level4CategoryId / 100) === 101121
      )
    },
    newExp() {
      const { giveInsure = 0 } = this.selectedSku || {}
      const lb = []
      if (
        this.product.isAnyTimeRefund === 0 &&
        this.product.isExpiredRefund === 0
      ) {
        lb.push({ title: '不可退', isGood: 0 })
      } else {
        if (this.product.isAnyTimeRefund === 1) {
          lb.push({ title: '随时退', isGood: 0 })
        }
        if (this.product.isExpiredRefund === 1) {
          lb.push({ title: '过期退', isGood: 0 })
        }
      }
      if (giveInsure) {
        lb.push({ title: '赠最高100万保险', isGood: 0 })
      }
      // if(!this.isRebuilding) {
      //   if (this.product.isSchedule * 1 === 1) {
      //     lb.push({ title: "需预约", isGood: 1 });
      //   } else {
      //     lb.push({ title: "免预约", isGood: 1 });
      //   }
      // }

      if (this.product.isPosPay * 1 === 1) {
        lb.push({ title: 'POS支付', isGood: 0 })
      }
      if (+this.product.spuType === PROUDCT_TYPE.YU_ER)
        lb.push({ title: 'PICC承保', isGood: 0 })
      return lb
    }
  },
  methods: {
    // showActionsheet() {
    //     this.$store.commit('showActionSheet')
    // },
    // ...mapMutations(["showActionSheet", "changeView", "setActionHeader"]),
    showLabels() {
      this.status = true
      // this.changeView("serveExplain");
      // this.setActionHeader({
      //   title: "服务说明",
      // });
      // this.showActionSheet();
    },
    handleClosed() {
      this.status = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.product-label {
  height: rem(80px);
  padding: 0 rem(30px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  .item-cell {
    padding: 0 0 rem(30px) 0;
  }
  .icon-more {
    color: #666;
  }
  li {
    display: inline-flex;
    align-items: center;
    position: relative;
    margin-right: rem(40px);
    font-size: rem(24px);
    color: #999;

    .iconfont {
      vertical-align: middle;
      // margin-right: rem(4px);
      font-size: rem(32px);
    }
    .icon-roundcheck {
      color: #ff397e;
    }
    .guanbi {
      color: #666;
    }
    &.active {
      color: #666;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  .item-cell-bd {
    height: 1.4em;
    // line-height: rem(30px);
    margin-right: rem(20px);
    margin-top: rem(2px);
    overflow: hidden;
    .title {
      font-size: rem(24px);
      color: #121212;
      position: relative;
      top: 0.015rem;
      margin-left: rem(6px);
    }
  }
  .icon-more {
    width: rem(20px);
    height: rem(20px);
  }
}

.newlabel {
  .header {
    font-size: rem(32px);
    color: #262626;
    line-height: rem(42px);
    text-align: left;
    margin: rem(48px) rem(24px) rem(36px);
    font-weight: bold;
    .iconClose {
      width: rem(40px);
      height: rem(40px);
      position: absolute;
      right: rem(24px);
      top: rem(46px);
      background: url('https://hzwimspic-1251601690.image.myqcloud.com/d7708d40-7d52-11eb-955e-df4b593726f9_size_60x60')
        no-repeat center center;
      background-size: rem(40px) rem(40px);
    }
  }
  .newlabelC {
    max-height: rem(600px);
    overflow: auto;
  }
  .btn {
    height: rem(100px);
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    .btnRed {
      background-image: linear-gradient(90deg, #ff8800 0%, #ff5900 100%);
      border-radius: rem(44px);
      width: rem(718px);
      height: rem(80px);
      font-size: rem(32px);
      color: #ffffff;
      text-align: center;
      line-height: rem(80px);
    }
  }
}
</style>
